import axios from "../utils/axios";

export const getTaskList = (data) => {
  return axios.post(
    `/AutonomousMaintenance/GetTaskPage/?expand=${true}&PageSize=${
      data.pageSize
    }&PageNumber=${data.pageNumber === undefined ? 1 : data.pageNumber}`,
    data
  );
};

export const getStatusList = () => {
  return axios.get("/AutonomousMaintenance/GetStatusList");
};

export const getUnplannedMaintenance = (data) => {
  return axios.get("UnplannedMaintenance/GetList?statusArr=" + data);
};

export const getAreaList = () => {
  return axios.get(`/Area/GetList`);
};

export const getTechnicianList = () => {
  return axios.get("/User/GetTechnicianList");
};

export const getCostCenterList = () => {
  return axios.get("/CostCenter/GetCostCenterList");
};

export const getMainListByAreaID = (areaID) => {
  return axios.get("/Equipment/GetMainListByAreaID?areaId=" + areaID);
};

export const getSubListById = (mainEquipmentID) => {
  return axios.get("/Equipment/GetSubListById?equipmentId=" + mainEquipmentID);
};

export const downloadExcelFile = (filter) => {
  return axios.post(`/AutonomousMaintenance/ExportTasks`, filter, {
    responseType: "blob",
  });
};
